import { useState } from "react";
import { createRole } from "../../services/adminService";
import toast from "react-hot-toast";

export default function CreateRole() {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error("Role name required");
      return;
    }

    try {
      setLoading(true);
      await createRole({ name });
      toast.success("Role created");
      setName("");
    } catch {
      toast.error("Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-semibold mb-4">Create Role</h2>

      <form onSubmit={handleSubmit}>
        <input
          className="w-full border p-3 rounded-lg"
          placeholder="Role Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <button
          className="mt-4 w-full bg-blue-600 text-white p-3 rounded-lg"
          disabled={loading}
        >
          {loading ? "Creating..." : "Create Role"}
        </button>
      </form>
    </div>
  );
}